import { css, html, LitElement } from "lit"

export default class PageContact extends LitElement {
  static properties = {}

  static styles = css``

  render() {
    return html`
    <main>
      <header>
        <h1>Contact</h1>
        <p>Tu as une question, une suggestion ou tu veux juste dire bonjour ? N'hésite pas à me contacter !</p>
      </header>

      <address>
        <ul>
            <li><strong>Email :</strong> <a href="mailto:luminecence.dev@gmail.com">luminecence.dev@gmail.com</a></li>
            <li><strong>Mp sur Discord :</strong> <a href="https://discord.com/users/342627083463426049" target="_blank" rel="noopener noreferrer">Luminecence</a></li>
        </ul>
      </address>
    </main>
        `
  }
}
customElements.define("p-page-contact", PageContact)
